import ClassAttendanceForm from '../components/ClassAttendanceForm'
import {
  PageContainer,
} from '../components/ui/StyledComponents'

function AttendancePage() {
  return (
    <PageContainer>
      <ClassAttendanceForm />
    </PageContainer>
  )
}

export default AttendancePage
